export const iconFontAwesomeConstructionPersonDigging = (
	<i className="fa-solid fa-person-digging"></i>
);
